module.exports = __webpack_public_path__ + "static/media/img1.08b545c8.png";